export default "__VITE_IMAGE_ASSET__5a8da41c__";